import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-about-us',
  imports: [RouterModule], // ✅ include RouterModule
  templateUrl: './about-us.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './about-us.css',
})
export class AboutUs {

}
